var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "email-onboarding__check-email flex-column ai-center" },
    [
      _c(
        "div",
        {
          staticClass:
            "email-onboarding__check-email--content flex-column ai-center"
        },
        [
          _c("div", { staticClass: "typographies-paragraph-medium-regular" }, [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.$l10n.__(
                    "Pour poursuivre la configuration, vous devez vérifier votre adresse email en cliquant sur le lien de vérification que vous allez recevoir sur celle-ci."
                  )
                ) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "flex-row email-onboarding__check-email--content-input-container"
            },
            [
              _c(
                "CompassFormItem",
                { attrs: { error: _vm.errorMsg } },
                [
                  _c("CompassInput", {
                    attrs: {
                      error: _vm.isInputInError,
                      placeholder: _vm.$t.__("common.labels.email")
                    },
                    on: { input: _vm.onInputEmail },
                    model: {
                      value: _vm.email,
                      callback: function($$v) {
                        _vm.email = $$v
                      },
                      expression: "email"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("CompassButton", {
                attrs: {
                  disabled: _vm.emailIsVerified || _vm.isInputInError,
                  label: _vm.$t.__("common.actions.verify"),
                  loading: _vm.isEmailSubmitLoading
                },
                on: { click: _vm.onClickSubmitEmail }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "typographies-paragraph-small-regular email-onboarding__check-email--content-input-caption"
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$l10n.__(
                      "Si vous souhaitez changer cette adresse email par la suite,"
                    )
                  )
              ),
              _c("br"),
              _vm._v(
                _vm._s(
                  _vm.$l10n.__(
                    " vous devrez procéder à une nouvelle vérification."
                  )
                ) + "\n        "
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm.emailIsVerified
        ? _c("CompassAlert", {
            staticClass: "email-onboarding__check-email--alert",
            attrs: {
              type: "success",
              description: _vm.$t.__(
                "email.EmailOnboardingCheckEmail.allready_verified_email"
              ),
              action: {
                label: _vm.$l10n.__("Continuer"),
                callback: function() {
                  return _vm.$emit("onClickContinue")
                }
              },
              "show-close": false
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }